<div class="name-header">
  <i class="far fa-user-circle btn-header-icon"></i>
  <div><span>{{"sidebar_menu.welcome" | translate}}, </span><span class="highlight">{{userFirstName}}</span></div>
</div>
<div class="profile-actions">
  <button [title]="'sidebar_menu.profile_information' | translate" mat-button class="sm-btn" (click)="onProfileClick()">{{"sidebar_menu.profile_information" | translate}}</button>
  <!-- <button mat-button class="sm-btn" [uwRouterLink]="['/donor',campaignGuid, 'settings','profile']">{{"sidebar_menu.profile_information" | translate}}</button> -->

  <button [title]="'common.past_donations' | translate" mat-button class="sm-btn" [uwRouterLink]="['/donor-info']" queryParamsHandling="merge">{{"common.past_donations" | translate}}</button>
  <!-- <button mat-button class="sm-btn" [uwRouterLink]="['/donor', campaignGuid, {outlets: {sidebar: ['change-password']}}]">{{"sidebar_menu.change_password" | translate}}</button> -->
  @if (!isSSOUser) {
    <button [title]="'sidebar_menu.change_password' | translate" mat-button class="sm-btn" (click)="onPasswordChange()">{{"sidebar_menu.change_password" | translate}}</button>
  }

</div>
<div class="profile-actions">
  <button [title]="'sidebar_menu.log_out' | translate" mat-button (click)="onLogout()">
    <i class="fas fa-cog"></i>
    {{"sidebar_menu.log_out" | translate}}
  </button>
</div>
<!-- <a
[uwRouterLink]="['/donor-info']"
> -->
